import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import Lenis from "lenis";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import CreatorDetail from "@/pages/CreatorDetail";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import PaymentStatus from "@/pages/PaymentStatus";
import ProtectedRoute from "@/components/ProtectedRoute";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return null;
}

function App() {
  return (
    <div className="App bg-background text-foreground">
      <div className="noise-overlay" />
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/creators/:id" element={<CreatorDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/payment/success" element={<PaymentStatus mode="success" />} />
            <Route path="/payment/cancel" element={<PaymentStatus mode="cancel" />} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
